var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7H28",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3L28 7L25 11",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4998 22.1501V25.9001C28.5012 26.2482 28.4299 26.5928 28.2904 26.9118C28.151 27.2308 27.9464 27.5171 27.6899 27.7525C27.4334 27.9878 27.1305 28.167 26.8007 28.2785C26.4709 28.39 26.1215 28.4315 25.7748 28.4001C21.9283 27.9822 18.2335 26.6678 14.9873 24.5626C11.9671 22.6435 9.40646 20.0828 7.48729 17.0626C5.37477 13.8016 4.0601 10.0889 3.64979 6.22512C3.61856 5.87945 3.65964 5.53107 3.77042 5.20215C3.8812 4.87323 4.05926 4.57098 4.29325 4.31465C4.52725 4.05831 4.81205 3.85351 5.12953 3.71327C5.44702 3.57304 5.79022 3.50045 6.13729 3.50012H9.88729C10.4939 3.49415 11.082 3.70897 11.542 4.10454C12.002 4.5001 12.3024 5.04943 12.3873 5.65012C12.5456 6.8502 12.8391 8.02853 13.2623 9.16262C13.4305 9.61003 13.4669 10.0963 13.3672 10.5637C13.2675 11.0312 13.0359 11.4603 12.6998 11.8001L11.1123 13.3876C12.8917 16.5171 15.4829 19.1082 18.6123 20.8876L20.1998 19.3001C20.5397 18.964 20.9687 18.7324 21.4362 18.6327C21.9037 18.533 22.3899 18.5694 22.8373 18.7376C23.9714 19.1608 25.1497 19.4543 26.3498 19.6126C26.957 19.6983 27.5115 20.0041 27.908 20.472C28.3044 20.9399 28.515 21.5371 28.4998 22.1501Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneForward);
export default __webpack_public_path__ + "static/media/phone-forward.ae0fcf9ca4e1f1811b979e1a737a3f9d.svg";
export { ForwardRef as ReactComponent };